;rwgps.templates=rwgps.templates||{};rwgps.templates.photos = {
uploader: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="photo_uploader">  <div class="progress.progress-success">    <div class="progress-bar"></div>  </div>  <span class="btn btn-default btn-sm fileinput-button add-photo-prompt">    <span>'+
((__t=( cta ))==null?'':_.escape(__t))+
'</span>    <input class="photos_upload" type="file" multiple="multiple"></div>';
}
return __p;
},
miniSlideshow: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="mini_slideshow carousel" id="'+
((__t=( carouselId ))==null?'':_.escape(__t))+
'"><ol class="carousel-indicators"></ol><div class="carousel-inner"></div><a href="javascript:;" class="carousel-control left"><i class="icon-prev"></i></a><a href="javascript:;" class="carousel-control right"><i class="icon-next"></i></a></div>';
}
return __p;
},
miniSlideshowIndicator: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
}
return __p;
},
miniSlideshowItem: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="item"><a class="popup_photo_modal" href="javascript:;" title="'+
((__t=( photo.caption || '' ))==null?'':_.escape(__t))+
'"><img class="ss_img" data-lazy-src="/photos/'+
((__t=( photo.id ))==null?'':__t)+
'/sq_thumb.jpg" alt="'+
((__t=( photo.caption || '' ))==null?'':_.escape(__t))+
'" data-lat="'+
((__t=( photo.lat ))==null?'':_.escape(__t))+
'" data-lng="'+
((__t=( photo.lng ))==null?'':_.escape(__t))+
'" data-photo-id="'+
((__t=( photo.id ))==null?'':_.escape(__t))+
'"></a></div>';
}
return __p;
},
modalSlideshow: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if(this.options.modal) { 
__p+='<div class="modal-dialog"><div class="modal-content"><div class="modal-body"><button class="close" type="button" data-dismiss="modal">&times;</button>';
 } 
__p+='<div class="inner"><div class="carousel" id="'+
((__t=( carouselId ))==null?'':_.escape(__t))+
'" data-interval="0"><ol class="carousel-indicators"></ol><div class="carousel-inner"></div><a href="javascript:;" class="carousel-control left"><i class="icon-prev"></i></a><a href="javascript:;" class="carousel-control right"><i class="icon-next"></i></a></div></div>';
 if(this.options.modal) { 
__p+='</div></div></div>';
 } 
__p+='';
}
return __p;
},
modalSlideshowIndicator: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li data-target="#'+
((__t=( carouselId ))==null?'':__t)+
'" data-slide-to="'+
((__t=( slideTo ))==null?'':__t)+
'" data-photo-id="'+
((__t=( photoId ))==null?'':__t)+
'"></li>';
}
return __p;
},
modalSlideshowItem: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="item"><div class="image_container"><img class="ss_img" data-lazy-src="/photos/'+
((__t=( photo.id ))==null?'':__t)+
'/large.jpg" alt="'+
((__t=( photo.caption || '' ))==null?'':_.escape(__t))+
'" data-lat="'+
((__t=( photo.lat ))==null?'':_.escape(__t))+
'" data-lng="'+
((__t=( photo.lng ))==null?'':_.escape(__t))+
'" data-photo-id="'+
((__t=( photo.id ))==null?'':_.escape(__t))+
'"></div><div class="below_image"><div class="controls_spacer"></div>';
 if(canEdit) { 
__p+='<div class="pull-right edit_actions">';
 if(belongsToPhotoset) { 
__p+='<a href="javascript:;" class="set_highlight">Set as cover</a>';
 } 
__p+='<a href="javascript:;" class="rotate_ccw"><i class="icon-rotate-left"></i></a><a href="javascript:;" class="rotate_cw"><i class="icon-rotate-right"></i></a><a href="javascript:;" class="remove"><i class="icon-trash"></i></a></div>';
 if(!photo.caption) { 
__p+='<div class="caption can_modify"><span class="nocaption">(click to add caption)</span></div>';
 } else { 
__p+='<div class="caption can_modify">'+
((__t=( photo.caption || '' ))==null?'':_.escape(__t))+
'</div>';
 } 
__p+='';
 } else { 
__p+='<div class="caption">'+
((__t=( photo.caption || '' ))==null?'':_.escape(__t))+
'</div>';
 } 
__p+='';
 if(photo.captured_at || photo.parent_type === "trip") { 
__p+='<small>';
 if(photo.captured_at) { 
__p+=''+
((__t=( photo.captured_at.strftime("%A, %B %e, %Y at %l:%M %p") ))==null?'':__t)+
'';
 } 
__p+='';
 if(photo.parent_type === "trip") { 
__p+='&nbsp;(<a href="/trips/'+
((__t=( photo.parent_id ))==null?'':__t)+
'">go to ride</a>)';
 } 
__p+='</small>';
 } 
__p+=''+
((__t=( shareBar ))==null?'':__t)+
'</div></div>';
}
return __p;
},
shareBar: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<ul class="share_bar list-inline list-unstyled"><li><a class="tt remember_this" href="/remember/'+
((__t=( assetType ))==null?'':__t)+
'/'+
((__t=( assetId ))==null?'':__t)+
'" title="Pin this so you can quickly find it later"><i class="icon-pushpin icon-large"></i></a></li><li>';
 var fb_uri = uri + "?fb_share=" + assetType + "&mode=manual" 
__p+='<a class="tt" href="http://facebook.com/sharer.php?u='+
((__t=( encodeURIComponent(fb_uri) ))==null?'':__t)+
'" title="Share this with your friends and family on Facebook" onclick="centeredpopup(this.href,\'\',600,600);return false;"><i class="icon-facebook-sign icon-large"></i></a></li><li><div class="dropup"><a href="#" data-toggle="dropdown" class="tt more-share-options dropdown-toggle">Share<span class="caret"></span></a><ul class="dropdown-menu"><li><a href="http://twitter.com/home?status='+
((__t=( encodeURIComponent(tweet) ))==null?'':__t)+
'" onclick="centeredpopup(this.href,\'\',600,600);return false;">Twitter</a></li><li><a href="http://plus.google.com/share?url='+
((__t=( encodeURIComponent(fb_uri) ))==null?'':__t)+
'" onclick="centeredpopup(this.href,\'\',600,600);return false;">  Google+</a></li><li><a class="share_bar_share_link" href="javascript:;" data-uri="'+
((__t=( uri ))==null?'':__t)+
'">Link</a></li>';
 if(assetType === 'photo') { 
__p+='<li><a target="_blank" href="/photos/'+
((__t=( assetId ))==null?'':__t)+
'/full.jpg">View original</a></li>';
 } 
__p+='</ul></div></li></ul>';
}
return __p;
}
};


//////////////////
// WEBPACK FOOTER
// ./public/javascripts/templates/photos.js
// module id = 37
// module chunks = 0